/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2022-01-07 15:55:19
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-03-15 11:37:04
 */
// 请求接口列表
export default {
  findUserInfo: '/cooperation/v1/user/info/getloginuserinfoFromContacts', // 获取登录用户信息
  getUsersInfoFromContacts: '/cooperation/v1/user/info/getUsersInfoFromContacts', // 获取登录用户信息
  logout: '/cooperation/v1/api/common/logout', // 退出登录接口
  getDocToken: '/cooperation/v1/identity/auth/getAccessToken', // 根据文档ID获取为知token
  createDoc: '/cooperation/v1/document/create', // 创建为知文件
  createCopy: '/cooperation/v1/document/createCopy', // 创建为知文件副本
  deleteDoc: '/cooperation/v1/document/delete', // 删除为知文件
  getDocData: '/cooperation/v1/document/getMetaDataWhthExtend', // 获取文档元数据
  fileExist: '/cooperation/v1/document/fileExist', // 文件是否存在
  editDocTitle: '/cooperation/v1/document/name/update', // 修改文件名称
  getUpdateTime: '/cooperation/v1/document/version/getLatestVersion', // 获取最后更新时间
  getVersionList: '/cooperation/v1/document/version/getVersions', // 获取历史版本
  getUserInfoByName: '/cooperation/v1/user/info/getUserInfo', // 获取人员详情
  getRecentlyUsersFromIM: '/cooperation/v1/user/info/getRecentlyUsersFromIM', // 获取最近联系人列表
  getUserListByName: '/cooperation/v1/user/info/searchUserListByName', // 人员模糊查询
  msgPush: '/cooperation/v1/message/info/msgPush', // @人员发送通知
  getCollectStatus: '/cooperation/v1/document/collection/docOtherInfo', // 获取收藏状态
  collectDoc: '/cooperation/v1/document/collection', // 点击收藏
  documentOpenRecord: '/cooperation/v1/document/documentOpenRecord', // 回传fileid
  filePreviewReordOnlineList: '/cooperation/v1/document/filePreviewReordOnlineList', // 最近浏览的文档
  getMyFileListByPage: '/cooperation/v1/document/getMyFileListByPage', // 我创建的文档
  documentFolderList: '/cooperation/v1/document/documentFolderList', // 在线文档目录
  selectTeamWorkerForAdd: '/cooperation/v1/document/teamworker/selectTeamWorkerForAdd', // 搜索人员
  searchGroupByNameForAdd: '/cooperation/v1/document/teamworker/searchGroupByNameforAdd', // 搜索群组
  batchAddTeamWorker: '/cooperation/v1/document/teamworker/batchAddTeamWorker', // 批量添加权限
  selectTeamWorkerForList: '/cooperation/v1/document/teamworker/selectTeamWorkerForList', // 获取协作者
  selectTeamWorkerForLock: '/cooperation/v1/document/teamworker/selectTeamWorkerForLock', // 获取可锁定人员列表
  updateTeamworkerPermission: '/cooperation/v1/document/teamworker/updateTeamworkerPermission', // 更新协作者权限
  deleteTeamWorker: '/cooperation/v1/document/teamworker/deleteTeamWorker', // 删除协作者
  documentAuth: '/cooperation/v1/identity/auth/documentAuth', // 文档权限
  agreeAuth: '/cooperation/v1/document/teamworker/agreeAuth', // 同意申请权限
  openShare: '/cooperation/v1/document/shareConfig/openShare', // 开启链接分享
  closeShare: '/cooperation/v1/document/shareConfig/closeShare', // 关闭链接分享
  selectShareConfigInfo: '/cooperation/v1/document/shareConfig/selectShareConfigInfo', // 获取是否开启链接状态
  changePasswordInfo: '/cooperation/v1/document/shareConfig/changePasswordInfo', // 刷新密码
  updateLinkPermission: '/cooperation/v1/document/shareConfig/updateLinkPermission', // 更改链接权限
  updateCallTermInfo: '/cooperation/v1/document/shareConfig/updateCallTermInfo', // 更新分享链接有效期
  teamWorkerCanRead: '/cooperation/v1/document/teamworker/teamWorkerCanRead', // 获取人员权限
  getVersionDataList: '/cooperation/v1/document/version/getVersionList', // 获取历史版本
  resetVersion: '/cooperation/v1/document/version/resetVersion', // 还原版本
  getVersionDetail: '/cooperation/v1/document/version/getVersionDetail', // 获取版本详情
  activeSaveVersion: '/cooperation/v1/document/version/activeSaveVersion', // 手动保存版本
  getSystemMenuOperate: '/cooperation/v1/system/menu/operate/getSystemMenuOperate', // 通用网页配置菜单
  sendMsgByIm: '/cooperation/v1/message/info/sendMsgByIm', // 给IM发送消息
  importNewOnLineFile: '/cooperation/v1/upload/bydocformat', // 导入为新在线文档
  getWaterMarkUrl: '/cooperation/v1/document/getWaterMarkUrl', // 请求预览地址
  getDocLibShareUrlUrl: '/cooperation/v1/document/getDocLibShareUrlUrl', // 请求分享云文档的预览地址
  createShare: '/cooperation/v1/document/doclibShare/createShare', // 创建文件库云文档分享
  sendCardSingleMsgByIm: '/cooperation/v1/message/info/sendCardSingleMsgByImv2', // 发送机器人消息
  ownerShareNotice: '/cooperation/v1/document/shareConfig/ownerShareNotice', // 我分享通知
  filePreviewList: '/cooperation/v1/user/info/filePreviewReordOnlineList',
  waterMark: '/cooperation/v1/document/waterMark', // 水印开、关接口
  getExcelGroupHistoryRecord: (fileId:string) => `/excel-server/v1/${fileId}/rest/getGroupHistoryZipRecord`, // 获取历史记录
  getMyCollectionByPage: '/cooperation/v1/user/info/getMyCollectionByPage', // 获取收藏列表
  saveExcelTable: (fileId:string, messageUId:string) => `/excel-server/v1/${fileId}/rest/saveTableInfo/${messageUId}`, // 保存表格最新数据
  getExcelFileHistorys: (fileId:string, versionType:string) => `/excel-server/v1/${fileId}/getFileHistorys/${versionType}`, // excel历史记录
  getImHistoryForVersionDifference: (fileId:string) => `/excel-server/v1/${fileId}/getImHistoryForVersionDifference`, // excel获取版本之间的op差异
  changeExcelVersionName: (fileId:string) => `/excel-server/v1/${fileId}/changeVersionName`, // 手动保存的历史版本名称修改
  excelRestoreHistoryVersion: (fileId:string) => `/excel-server/v1/${fileId}/restoreHistoryVersion `, // excel还原到某一版本
  excelRestoreHistoryOp: (fileId:string) => `/excel-server/v1/${fileId}/restore2MsgVersion`, // // excel还原到某一op
  copyAnnexRelations: (fileId:string) => `/excel-server/v1/${fileId}/copyAnnexRelations`, // // 复制附件到当前文件
  searchParamByPage: '/cooperation/v1/business/param/getEditParams', // 获取业务模板参数列表
  getBusinessAuth: '/cooperation/v1//business/user/getBusinessAuth', // 获取设置参数域的权限
  docOnlineNewsPush: '/cooperation/v1/message/info/docOnlineNewsPush', // 消息推送
  doclibNewsPush: '/cooperation/v1/message/info/doclibNewsPush', // 给文档库推定制消息
  createTask: '/cooperation/v1/document/task/create', // 推送任务
  updateTaskStatus: '/cooperation/v1/document/task/updateTaskStatus', // 更新任务状态任务
  shimoRecentFiles: '/cooperation/v1/user/info/getRecentFiles', // 石墨文档列表
  getLongXinMyCreateList: '/cooperation/v1/user/info/getLongXinMyCreateList', // 石墨文档最近浏览
  getDocumentHeaderFooter: (fileId:string) => `/cooperation/v1/document/getDocumentHeaderFooter?fileId=${fileId}`, // 页眉页脚配置查询
  saveHeaderFooterConfig: '/cooperation/v1/document/saveHeaderFooterConfig', // 页眉页脚配置保存
  getStsToken: '/cooperation/v1/getStsToken', // 获取oss-token
  getStsTokenByFileId: (fileId:string) => `/excel-server/v1/${fileId}/getStsToken`, // 获取oss-token
  getTaskBlockInfo: '/cooperation/v1/document/task/getTaskBlockInfo', // 获取文档已经推送过的任务
  setDocOperateLog: '/cooperation/v1/doc/operation/log', // 记录word下载和excel下载
  updateFileRoleConfig: '/cooperation/v1/document/shareConfig/updateFileRoleConfig', // 更新权限设置
  fileExportAuth: '/cooperation/v1/document/fileExportAuth/update', // 更新权限设置——文件导出权限
  fetchWikiListByKeyword: '/cooperation/v1/document/wikiSearch/search', // [WIKI] 根据 keyword 获取 Wiki 列表
  getSpaceList: '/cooperation/v1/document/task/getSpaceList', // 获取团队空间列表
  findTaskPackage: '/cooperation/v1/document/task/findTaskPackage', // 获取团队任务清单列表
  openBatchFiles4LieYing: '/cooperation/v1/document/openBatchFiles4LieYing', // 猎鹰获取多个表数据，根据fileId查询
  openWithParam: '/cooperation/v1/document/openWithParam', // 猎鹰获取多个表数据
  createSubNode: '/cooperation/v1/subDocument/createSubNode', // 子文档新建
  getSubDocument: '/cooperation/v1/subDocument/getSubDocument', // 获取子文档
  deleteSubNode: '/cooperation/v1/subDocument/deleteSubNode', // 删除子文档
  editSubNode: '/cooperation/v1/subDocument/editSubNode', // 删除子文档
  moveSubNode: '/cooperation/v1/subDocument/moveSubNode' // 移动子文档
}
